import { useIsMobile } from '@/hooks/use-mobile'
import { UpcomingUnlocksBaseProps } from './UpcomingUnlocksBase'
import { UpcomingUnlocksMobile } from './UpcomingUnlocksMobile'
import { UpcomingUnlocksDesktop } from './UpcomingUnlocksDesktop'

/**
 * Unified UpcomingUnlocks component that renders mobile or desktop version
 * Uses useIsMobile hook to conditionally render the appropriate version
 * This approach separates mobile and desktop code completely
 */
export const UpcomingUnlocks = (props: UpcomingUnlocksBaseProps) => {
  const isMobile = useIsMobile()

  // Completely separate mobile and desktop rendering
  // No CSS classes mixing - pure conditional rendering
  if (isMobile) {
    return <UpcomingUnlocksMobile {...props} />
  }

  return <UpcomingUnlocksDesktop {...props} />
}

